import React, { useState, useEffect } from "react";
import axios from "axios";
import api from "../../api/axiosInstance";

const ChangePasswordModal = () => {
  const [form, setForm] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    setError("");

    if (!form.currentPassword || !form.newPassword || !form.confirmPassword) {
      return setError("All fields are required");
    }

    if (form.newPassword !== form.confirmPassword) {
      return setError("New Passwords and Confirm Passwords do not match");
    }

    if (form.newPassword.length < 6) {
      return setError("Password must be at least 6 characters");
    }

    try {
      setLoading(true);

      await axios.post(
        `${process.env.REACT_APP_API_URL}/admin/changePassword`,
        {
          currentPassword: form.currentPassword,
          newPassword: form.newPassword,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      alert("Password updated successfully");

      document.getElementById("closeChangePwdModal").click();

      setForm({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      });
    } catch (err) {
      setError(err.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  // Reset error and form when modal is closed
  useEffect(() => {
    const modalEl = document.getElementById("changePasswordModal");

    const handleClose = () => {
      setError("");
      setForm({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      });
    };

    if (modalEl) {
      modalEl.addEventListener("hidden.bs.modal", handleClose);
    }

    return () => {
      if (modalEl) {
        modalEl.removeEventListener("hidden.bs.modal", handleClose);
      }
    };
  }, []);

  return (
    <div className="modal fade" id="changePasswordModal" tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Change Password</h5>
            <button
              id="closeChangePwdModal"
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
            />
          </div>

          <div className="modal-body">
            {error && <div className="alert alert-danger">{error}</div>}

            <div className="mb-3">
              <label>Current Password</label>
              <input
                type="password"
                className="form-control"
                name="currentPassword"
                value={form.currentPassword}
                onChange={handleChange}
              />
            </div>

            <div className="mb-3">
              <label>New Password</label>
              <input
                type="password"
                className="form-control"
                name="newPassword"
                value={form.newPassword}
                onChange={handleChange}
              />
            </div>

            <div className="mb-3">
              <label>Confirm New Password</label>
              <input
                type="password"
                className="form-control"
                name="confirmPassword"
                value={form.confirmPassword}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="modal-footer">
            <button className="btn btn-secondary" data-bs-dismiss="modal">
              Cancel
            </button>
            <button
              className="btn btn-primary"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "Updating..." : "Update Password"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePasswordModal;
